import Client from '../../helpers/ApiClient';
import Component from '../Component';
import Lookup from './Lookup';
import {Button} from 'react-bootstrap';
import React from 'react';
import immutable from 'immutable';
import {ModalWindow} from 'reactis-modal';
import VehicleForm from '../../containers/Vehicle/Form';

export default class VehicleLookup extends Component {

	static contextTypes = {
		store: React.PropTypes.object
	};

	api(q, page) {
		const client = new Client();
		return client.call('vehicle.lookup', {q: q, page: page, firm: this.props.client});
	}

	formatResult(result, container, query, escapeMarkup) {
		var markup=[];
		window.Select2.util.markMatch(result.text, query.term, markup, escapeMarkup);
		var title = markup.join("");
		let subtitle = '<div class="lookup-subtitle">' + (result.cTitle ? result.cTitle : '')+ '</div>';
		return '<div>'+title+'</div>' + subtitle;
	}

	handleHide(id) {
		this.popup.hide();
	}

	handleSave(data) {
		this.popup.hide();
		const value = immutable.Map({id: data.id, text: data.title});
		this.props.onChange(value);
	}

	handleAdd(e) {
		e.preventDefault();

		this.popup = new ModalWindow('Nový vozík',
			<VehicleForm popup={true} onClose={() => this.handleHide()} onSave={(data) => this.handleSave(data)} />);
		this.popup.show(this.context.store.dispatch);
	}

	render() {
		const comp = <Lookup dropdownWidth="270"
							 formatResult={this.formatResult.bind(this)}
							 query={(q, page) => this.api(q, page)}
							{...this.props} />;

		if (!this.props.addButton) {
			return comp;
		}
		return (
			<div>
				<table className="lookup" style={{width:'100%'}}>
					<tbody>
						<tr>
							<td>
								{comp}
							</td>
							<td style={{width:16}}>
								<Button title="nový vozík" onClick={(e) => this.handleAdd(e)}>+</Button>
							</td>
						</tr>
					</tbody>
				</table>

			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/VehicleLookup.js